const flushCallbacks = new Set()

export const registerPendingSiteSaveFlush = (flush) => {
  if (typeof flush !== 'function') {
    return () => {}
  }

  flushCallbacks.add(flush)
  return () => {
    flushCallbacks.delete(flush)
  }
}

export const flushPendingSiteSaves = async () => {
  const results = [...flushCallbacks].map((flush) => {
    try {
      return flush()
    } catch (_error) {
      return undefined
    }
  })

  await Promise.all(
    results.map((result) => {
      if (result && typeof result.then === 'function') {
        return result
      }
      return Promise.resolve()
    })
  )
}
